import styled from '@emotion/styled';

import Button from '../button';
import theme from '../../theme';

export const InternalContainer = styled.div`
  max-width: ${theme.screenLgMax};
  margin: auto;

  @media (max-width: ${theme.screenLgMax}) {
    padding-left: 24px;
    padding-right: 24px;
  }
`;

export const StyledDisplay = styled.h1`
  font-size: 56px;
  font-weight: bold;
  line-height: 84px;
  color: ${theme.colorsBlack};
`;

export const StyledH1 = styled.h1`
  font-size: 40px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
`;

export const StyledH5 = styled.h5`
  font-size: 18px;
  color: ${theme.colorsBlack};
  font-weight: bold;
`;

export const StyledHtmlContainer = styled.div`
  color: ${theme.colorsBlack};
  font-size: 18px;
  letter-spacing: 0;
`;

export const StyledButton = styled(Button)`
  &.ant-btn {
    max-width: 100%;
    width: auto;
  }
`;

export const StyledImage = styled.img`
  width: 100%;
  border-radius: 5px;
`;

export const Logo = styled.img`
  height: auto;
  width: auto;
  max-height: 80px;
  max-width: 80px;
`;

export const SectionBackground = styled.div`
  background-color: #f5f5f5;
  height: 100%;
  width: 100%;
  max-height: 498px;
  max-width: 1088px;
  position: absolute;
  @media (max-width: ${theme.screenLgMax}) {
    max-height: 952px;
  }
  @media (max-width: ${theme.screenXsMax}) {
    max-height: 820px;
  }
`;
